import React, { useState, useEffect, useRef, memo } from 'react';
import { makeStyles, Button, Grid } from '@material-ui/core';
import { rollSkill } from '../utils/RollDice'

import DiceModal from './DiceModal'


const useStyles = makeStyles((theme) => ({
  diceDiv: {
    padding: theme.spacing(1, 1, 0),
    textAlign: 'center',
    border: '2px solid white',
    color: 'white',
    minHeight: '100%'
  },
  text: {
    margin: 0
  },
  amountDice: {
    color: theme.palette.grey
  },
  button: {
    width: '100%'
  }
}));

const SkillCard = (props) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [diceValue, setDiceValue] = useState(-1);
  const [successText, setSuccessText] = useState('Carregando');

  const modalRef = useRef();



  const handleOpen = () => {
    setDiceValue(-1)
    modalRef.current.handleOpen();

    setTimeout(function () {
      const [resultText, resultNumber] = rollSkill(props.skillValue)
      setSuccessText(resultText)
      setDiceValue(resultNumber)
    }, 1500);
  };

  // useEffect(()=> console.log('renderizei ' + props.skillName))

  const modalBody = (
    <React.Fragment>
      <h2 id="simple-modal-title">{props.skillName + ' - ' + successText + ' - ' + diceValue}</h2>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <Grid
        className={classes.diceDiv}
        container
        direction="column"
        justify="flex-start"
        alignItems="stretch"
      >
        <Button
          className={classes.button}
          variant="contained" onClick={handleOpen}>
          {props.skillValue}
        </Button>
        <h1 className={classes.text}>{props.skillName}</h1>
      </Grid>

      <DiceModal
        ref={modalRef}
        diceValue={diceValue}
      >
        {modalBody}
      </DiceModal>
    </React.Fragment>
  );
}

export default memo(SkillCard);